class KCVS.Collections.ProcurementDocuments extends Backbone.Collection
  model: KCVS.Models.ProcurementDocument

  initialize: (models,options) ->
    @procurementId = options.procurementId

  url: ->
    "/procurements/#{@procurementId}/documents"
